var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M21.2823 4.5007C22.311 4.77608 23.1195 5.58449 23.3948 6.61321C23.8925 8.4759 23.8945 12.3646 23.8945 12.3646C23.8945 12.3646 23.8945 16.2532 23.3948 18.1159C23.1195 19.1446 22.311 19.9531 21.2823 20.2284C19.4197 20.728 11.9472 20.728 11.9472 20.728C11.9472 20.728 4.4748 20.728 2.6121 20.2284C1.58339 19.9531 0.774977 19.1446 0.499604 18.1159C0 16.2532 0 12.3646 0 12.3646C0 12.3646 0 8.4759 0.499604 6.61321C0.774977 5.58449 1.58339 4.77608 2.6121 4.5007C4.4748 4.0011 11.9472 4.0011 11.9472 4.0011C11.9472 4.0011 19.4197 4.0011 21.2823 4.5007ZM15.7624 12.3649L9.55469 15.9487V8.78113L15.7624 12.3649Z","fill":"white"}));
}

Youtube.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","role":"img","aria-label":"Youtube svg image"};

module.exports = Youtube;

Youtube.default = Youtube;
